import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { SuiteShellProvider } from '@levelup/ui-shell';
import '@levelup/ui-shell/styles.css';
import App from './App';
import { store } from './store';
import { beheardShellAdapter } from './shell/beheardShellAdapter';
import { handleSilentCallbackIfFramed } from './auth/silentCallbackBridge';
import './styles/index.css';

// ── The hidden silent-renewal frame stops here ───────────────────────────
//
// A silent access-token renewal (auth/silentAuthorize.ts) points a hidden frame
// at Central's authorize endpoint, and Central redirects back to BeHeard's
// registered redirect URI — this application. Mounting a second copy of the SPA
// in that frame would consume the single-use authorization code in a document
// that is about to be removed, so the parent would never get its token.
//
// `handleSilentCallbackIfFramed` posts the authorize answer to the parent and
// returns true ONLY for a framed callback whose `state` marks it as silent.
// Every other load — including an ordinary interactive login callback — boots
// normally.
if (!handleSilentCallbackIfFramed(window)) {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <HelmetProvider>
        <Provider store={store}>
          <BrowserRouter>
            <SuiteShellProvider adapter={beheardShellAdapter}>
              <App />
              <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
            </SuiteShellProvider>
          </BrowserRouter>
        </Provider>
      </HelmetProvider>
    </React.StrictMode>
  );
}
